import axios from "axios";

let baseURL = "";

baseURL = "https://aimily-api.laidback.co.kr";
// baseURL = "http://localhost:4005";

export default axios.create({
	baseURL: baseURL,
});
